import { ObjectHash, Theme } from '../../../../types/shared'
import { ChartEventBadgeType } from '../../../constants/common'
import { ChartEventBadgeState, IChartEventBadgeProps } from '../utils'
import { chartBadgeSvgByType } from './chart-badges-svg-by-type'

const badgeImages = {} as ObjectHash<HTMLImageElement, string>
export const CHART_EVENT_BADGE_SIZE = 24

type ChartEventBadgeCommonType = Omit<IChartEventBadgeProps, 'width'> & { badgeType: ChartEventBadgeType }

function getSvgImageCacheKey(props: Pick<ChartEventBadgeCommonType, 'badgeType' | 'theme' | 'state'>) {
  return `${props.badgeType}-${props.theme}-${props.state}`
}

async function cacheEventBadgeSvg(props: ChartEventBadgeCommonType) {
  const cacheKey = getSvgImageCacheKey(props)
  const svgHTML = chartBadgeSvgByType[props.badgeType]({ ...props, width: CHART_EVENT_BADGE_SIZE })
  const img = new Image()
  img.src = `data:image/svg+xml,${encodeURIComponent(svgHTML)}`
  badgeImages[cacheKey] = img
}

function prefetchEventBadgeSvgs() {
  Object.values(ChartEventBadgeState).forEach((badgeState) => {
    Object.values(ChartEventBadgeType).forEach((badgeType) => {
      Object.values(Theme).forEach((theme) => {
        void cacheEventBadgeSvg({
          badgeType,
          state: badgeState,
          theme,
        })
      })
    })
  })
}

if (typeof window !== 'undefined') {
  prefetchEventBadgeSvgs()
}

export function getChartEventBadgeImage(props: ChartEventBadgeCommonType) {
  const cacheKey = getSvgImageCacheKey(props)
  return badgeImages[cacheKey]
}
